export default "__VITE_ASSET__vUefmRfR__";